import axios from "axios";

// Use base URL from environment
const backendOrigin = (process.env.REACT_APP_BACKEND_ORIGIN || '').replace(/\/?$/, '/');
const instance = axios.create({
  baseURL: backendOrigin
});

export const callGetUserCredentials = () => instance.get<string[]>("api/user/credentials");

export const callGetNewToken = () => instance.get<string>("api/user/new_token");

export const callGetToken = () => instance.get<string>("api/user/token");